<template>
	<div class="wrap">
		<div class="container">
			<div class="review_goods_box">

                <van-list v-model="loading" loading-text="加载中..." :finished="finished" finished-text="" @load="getList">
					<div class="review_list" v-for="(value,index) in data_list" :key="'data_list'+index">
						<van-row type="flex" class="review_goods">
							<van-col span="8" class="title">
								<van-image width="100%" :src="value.goods.images" />
								<div class="van-multi-ellipsis--l2">{{value.goods.title}}</div>
							</van-col>
							<van-col span="16">
								<div class="makereview list_two">
									<div class="">{{value.add_time_text}}</div>
									<van-row class="make_star" type="flex" align="center" justify="space-between">
										<van-col class="fl">
											<van-rate v-model="value.rating" :size="15" color="#000000" readonly />
										</van-col>
										<van-col class="fr"></van-col>
									</van-row>
										
									<van-row type="flex" class="review_img">
										<video width="20%" :src="value.video" controls v-if="value.video != ''" ></video>
										<van-image width="20%" v-for="(vv,ii) in value.images"  :key="'dl'+ii" :src="vv" @click="showImages(value.images)" />
									</van-row>
									<div class="review_nr">{{value.content}}</div>
								</div>
							</van-col>
						</van-row>
							<div class="reply" v-if="value.reply !='' ">
								<div class="reply_m">
									<div class="reply-con">{{value.reply}}</div>
							</div>
						</div>
					</div>
				</van-list>
				<van-empty description="没有更多了..." v-if="data_list.length<1" />
				

			</div>
		</div>
		<v-foot></v-foot>
	</div>
</template>

<script>
	var _this;
	// @ is an alias to /src
    import { ImagePreview } from 'vant';
	export default {
		components: {},
		created(){
			_this = this;
		},
		data() {
			return {
				page: 1,
				data_list:[],
				finished:false,
				loading:false,
				status_getlist:true,
			}
		},
		methods: {
			getList(){
				if(this.status_getlist){
					this.status_getlist = false;
					this.POST("/api/userfavor/myreviews",{"page":this.page},function (d) {
						// window.console.log(d);
						if(d.code == 0){
							if(_this.data_list.length == 0){
								_this.data_list 	= d.data.data_list;
							}else{
								_this.data_list = _this.data_list.concat(d.data.data_list)
							}
							window.console.log(_this.page+" --- "+d.data.data_list.length +"<"+ d.data.page_size);
							if(d.data.data_list.length < d.data.page_size){
								_this.finished = true;
							}
							_this.loading = false;
							_this.page = _this.page+1;		
							_this.status_getlist = true;			
						}
					})
				}
			},
            showImages(images){
                ImagePreview({images,closeable:true})
            }

		},
	}
</script>